// extracted by mini-css-extract-plugin
export const root = "profile-module--root--5GEcZ";
export const table = "profile-module--table--J6any";